import { render, staticRenderFns } from "./UserEditChangeEmail.vue?vue&type=template&id=5fbc6cc0&scoped=true&"
import script from "./UserEditChangeEmail.vue?vue&type=script&lang=js&"
export * from "./UserEditChangeEmail.vue?vue&type=script&lang=js&"
import style0 from "./UserEditChangeEmail.vue?vue&type=style&index=0&id=5fbc6cc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc6cc0",
  null
  
)

export default component.exports